import { APP_NAME, ENV, WALLET_CONNECT_PROJECT_ID } from "./env.config";
import { connectorsForWallets } from "@rainbow-me/rainbowkit";
import {
    rabbyWallet,
    phantomWallet,
    metaMaskWallet,
    walletConnectWallet,
    coinbaseWallet,
    rainbowWallet,
    safeWallet,
} from "@rainbow-me/rainbowkit/wallets";
import { type PublicClient, createPublicClient, http, fallback } from "viem";
import { createConfig } from "wagmi";
import { mainnet } from "wagmi/chains";

const projectId = WALLET_CONNECT_PROJECT_ID;
const appName = APP_NAME;
const shouldConfigureWalletConnect = ENV !== "test" && Boolean(projectId);

const chains = [mainnet] as const;

// from: https://chainlist.org/?chain=1, https://chainlist.org/?chain=42161
const HTTP_RPCS = {
    [mainnet.id]: [
        "https://ethereum-rpc.publicnode.com",
        "https://ethereum-public.nodies.app",
        "https://0xrpc.io/eth",
        "https://rpc.flashbots.net",
        "https://eth.drpc.org",
        "https://eth.llamarpc.com",
        "https://rpc.mevblocker.io",
    ],
    // [arbitrum.id]: [
    //     "https://arbitrum-one-rpc.publicnode.com",
    //     "https://arb1.arbitrum.io/rpc",
    //     "https://api.zan.top/arb-one",
    //     "https://rpc.poolz.finance/arbitrum",
    // ],
} as const;

const fallbackTransport = fallback(
    HTTP_RPCS[mainnet.id].map((rpc) => http(rpc)),
    { rank: false },
);

const connectors = shouldConfigureWalletConnect
    ? connectorsForWallets(
          [
              {
                  groupName: "Recommended",
                  wallets: [
                      rabbyWallet,
                      phantomWallet,
                      metaMaskWallet,
                      walletConnectWallet,
                      coinbaseWallet,
                      rainbowWallet,
                      safeWallet,
                  ],
              },
          ],
          {
              appName,
              projectId,
          },
      )
    : [];

export const publicClients: Record<number, PublicClient> = {
    [mainnet.id]: createPublicClient({
        chain: mainnet,
        transport: fallbackTransport,
    }),
};

export const wagmiConfig = createConfig({
    chains,
    connectors,
    transports: {
        [mainnet.id]: fallbackTransport,
    },
    ssr: false,
});
